import React, { useState, useEffect } from "react";
import "../Table/Table.css";
import Loading from "../Loading";
import DataTable from "../DataTable/DataTable";
import { Tooltip } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast';
import Discrepancy from "../Discrepancy/Discrepancy";
import { useErrorToast } from "../../hooks/useErrorToast";
import { PiFileCsv } from "react-icons/pi";
import { AiOutlineClose } from "react-icons/ai";
function LocationDetail({ data, contractNumber, onClose }) {
    const showError = useErrorToast();
  const [loadingFull, setLoadingFull] = useState(false);
  const [discrepancyModal, setDiscrepancyModal] = useState(false);
  const [discrepancyData, setDiscrepancyData] = useState([]);
  const [invoiceNo, setInvoiceNo] = useState("");
  const [selectedColumn, setSelectedColumn] = useState({});
  const [invoice, setInvoice] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchInvoice();
  }, []);

  const fetchInvoice = async (status = true) => {
    try {
      const token = localStorage.getItem("tokenInv");
      // const params = new URLSearchParams(search);
      let url = `${process.env.REACT_APP_URL}/get-all-invoices`;
      let response = await axios.get(
        url,
        // `${process.env.REACT_APP_URL}/get-all-invoices?search_for=`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
      let data = response.data.data.map((el) => ({
        ...el,
        status: el?.status === "processed" ? "Processed" : "Pending",
        discrepancy_detected: el.discrepancy_detected ? "True" : "False",
        // taxes_and_surcharges: el?.taxes_and_surcharges
        //   ? el?.taxes_and_surcharges?.toFixed(2)
        //   : "",
        // total_amount: el?.total_amount
        //   ? parseInt(el?.total_amount).toFixed(2)
        //   : "",
        // total_usd: el?.total_usd ? el?.total_usd?.toFixed(2) : "",
        taxes_and_surcharges: el?.taxes_and_surcharges
          ? Number(el.taxes_and_surcharges).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          : "",
        total_amount: el?.total_amount
          ? Number(el.total_amount).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          : "",
        total_usd: el?.total_usd
          ? Number(el.total_usd).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          : "",
        invoice_date: el?.invoice_date ? new Date(el?.invoice_date) : "",
        final_discrepancy:
          parseInt(el.total_discrepancy) - parseInt(el.total_adj),
      }));
      // console.log("data",data)
      setInvoice(data);
    } catch (error) {
      if (error.response.status === 401) {
        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        showError(error?.response?.data?.message || "Something went wrong. Please try again.");
        // toast.error(
        //   error.response.data.message ||
        //     "Something went wrong. Please try again."
        // );
      }
    }
  };

  const handleDownloadCSV = () => {
    const csvRows = [];
    const headers = [
      "Invoice ID",
      "Service ID",
      "Service Name",
      "Service Description",
      "Document ID",
      "Charge Period",
      "Charge Type",
      "Currency",
      "Amount (Local)",
      "Amount (USD)",
      "Discount (Local)",
      "Discount (USD)",
      "Taxes (Local)",
      "Taxes (USD)",
      "NET Total (Local)",
      "NET Total (USD)"
    ];
    csvRows.push(headers.join(","));

    data?.data?.forEach((invoice) => {
      const formatString = (val) => `"\t${String(val).replace(/"/g, '""')}"`;
      const formatNumber = (val) => `"${String(val).replace(/"/g, '""')}"`;

      const row = [
        formatString(invoice?.invoice_id || "N/A"),
        formatString(invoice?.service_id || "N/A"),
        formatNumber(invoice?.service_name || "N/A"),
        formatNumber(invoice?.service_description ? invoice.service_description.replace(/\n/g, " ") : "N/A"),
        formatString(invoice?.doc_id || "N/A"),
        formatNumber(invoice?.charge_period || "N/A"),
        formatNumber(invoice?.charge_type || "N/A"),
        formatNumber(invoice?.currency || "N/A"),
        formatNumber(invoice?.amount != null ? invoice.amount : "N/A"),
        formatNumber(invoice?.amount_usd != null ? invoice.amount_usd : "N/A"),
        formatNumber(invoice?.["discount_&_promotion"] != null ? invoice["discount_&_promotion"] : "N/A"),
        formatNumber(invoice?.discount_usd != null ? invoice.discount_usd : "N/A"),
        formatNumber(invoice?.["taxes_&_surcharges"] != null ? invoice["taxes_&_surcharges"] : "N/A"),
        formatNumber(invoice?.taxes_usd != null ? invoice.taxes_usd : "N/A"),
        formatNumber(invoice?.total_usd != null ? invoice.total_usd : "N/A"),
        formatNumber(invoice?.converted_total_usd != null ? invoice.converted_total_usd : "N/A"),
      ];
      csvRows.push(row.join(","));
    });

    const csvContent = "data:text/csv;charset=utf-8," + csvRows.join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `Location_Details_${contractNumber}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const columns = [
    {
      field: "invoice_id",
      headerName: "Invoice ID",
      width: 130,
      renderCell: (params) => (
        <Tooltip title="View invoice detail">
          <span
            onClick={() => fetchInvoiceDetails(params.value)}
            style={{
              color: "blue",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    { field: "service_id", headerName: "Service ID", width: 120 },
    { field: "service_name", headerName: "Service Name", width: 200 },
    {
      field: "service_description",
      headerName: "Service Description",
      width: 250,
    },
    { field: "doc_id", headerName: "Document ID", width: 130 },
    { field: "charge_period", headerName: "Charge Period", width: 150 },
    { field: "charge_type", headerName: "Charge Type", width: 130 },
    { field: "currency", headerName: "Currency", width: 90 },
    { field: "amount", headerName: "Amount (Local)", width: 130 },
    { field: "amount_usd", headerName: "Amount (USD)", width: 120 },
    {
      field: "discountpromotion",
      headerName: "Discount (Local)",
      width: 130,
    },
    { field: "discount_usd", headerName: "Discount (USD)", width: 130 },
    { field: "taxessurcharges", headerName: "Taxes (Local)", width: 120 },
    { field: "taxes_usd", headerName: "Taxes (USD)", width: 120 },
    { field: "total_usd", headerName: "NET Total (Local)", width: 120 },
    { field: "converted_total_usd", headerName: "NET Total (USD)", width: 120 },
  ];

  const fetchInvoiceDetails = async (invId) => {
    setLoadingFull(true);
    try {
      const token = localStorage.getItem("tokenInv");
      let response = await axios.get(
        `${process.env.REACT_APP_URL}/get-discrepancy/${invId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
      let data = response.data.data.map((el, index) => {
        return {
          ...el,
          id: index,
          service_name_y: el.service_name_y || el.service_name_x,
          amount: el.amount ? parseInt(el.amount).toFixed(2) : 0,
          location_id_y: el?.location_id_y || el?.location_id_x,
        };
      });
      setDiscrepancyData(data);
      setInvoiceNo(invId);
      setDiscrepancyModal(true);
      let invDetail = invoice.find((el) => el.invoice_id === invId);
      setSelectedColumn(invDetail);
    } catch (error) {
      if (error.response.status === 401) {
        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        showError(error?.response?.data?.message || "Something went wrong. Please try again.");
        // toast.error(
        //   error.response.data.message ||
        //     "Something went wrong. Please try again."
        // );
      }
    } finally {
      setLoadingFull(false);
    }
  };

  const rows = data?.data?.map((invoice, index) => ({
    id: index,
    invoice_id: invoice?.invoice_id || "N/A",
    service_id: invoice?.service_id || "N/A",
    service_name: invoice?.service_name || "N/A",
    service_description: invoice?.service_description
      ? invoice.service_description.replace(/\n/g, " ")
      : "N/A",
    doc_id: invoice?.doc_id || "N/A",
    charge_period: invoice?.charge_period || "N/A",
    charge_type: invoice?.charge_type || "N/A",
    // amount: invoice?.amount || 'N/A',
    // discountpromotion: invoice?.['discount_&_promotion'] || 'N/A',
    // taxessurcharges: invoice?.['taxes_&_surcharges'] || 'N/A',
    // total_usd: invoice?.total_usd || 'N/A'
    currency: invoice?.currency || "N/A",
    amount: invoice?.amount
      ? Number(invoice.amount).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "0.00",
    amount_usd: invoice?.amount_usd
      ? Number(invoice.amount_usd).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "0.00",
    discountpromotion: invoice?.["discount_&_promotion"]
      ? Number(invoice["discount_&_promotion"]).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "0.00",
    discount_usd: invoice?.discount_usd
      ? Number(invoice.discount_usd).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "0.00",
    taxessurcharges: invoice?.["taxes_&_surcharges"]
      ? Number(invoice["taxes_&_surcharges"]).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "0.00",
    taxes_usd: invoice?.taxes_usd
      ? Number(invoice.taxes_usd).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "0.00",
    total_usd: invoice?.total_usd
      ? Number(invoice.total_usd).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "0.00",
    converted_total_usd: invoice?.converted_total_usd
      ? Number(invoice.converted_total_usd).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "0.00",
  }));

  return (
    <>
      {loadingFull && <Loading />}
<Toaster position="top-right" reverseOrder={false}/>
      <div className="table-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '15px' }}>
        <h2 style={{ margin: 0, fontSize: '1.2rem', color: '#7C2EA0' }}>Location ID - {contractNumber} (Invoices)</h2>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Tooltip title="Download CSV" placement="top" arrow>
            <span
              onClick={handleDownloadCSV}
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                width: "32px",
                height: "32px",
                backgroundColor: "#f5f5f5",
                cursor: data?.data?.length > 0 ? "pointer" : "default",
                opacity: data?.data?.length > 0 ? 1 : 0.5,
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                if (data?.data?.length > 0) {
                  e.currentTarget.style.backgroundColor = "#e0e0e0";
                }
              }}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#f5f5f5")}
            >
              <PiFileCsv size={18} color="#7C2EA0" />
            </span>
          </Tooltip>
          {onClose && (
            <Tooltip title="Close" placement="top" arrow>
              <span
                onClick={onClose}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "50%",
                  width: "32px",
                  height: "32px",
                  backgroundColor: "#f5f5f5",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#e0e0e0")}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#f5f5f5")}
              >
                <AiOutlineClose size={16} color="#333" />
              </span>
            </Tooltip>
          )}
        </div>
      </div>
      
      {data?.data?.length > 0 && (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-around', 
          padding: '15px 20px', 
          borderTop: '1px solid #ede5f3', 
          borderBottom: '1px solid #ede5f3', 
          marginBottom: '15px', 
          backgroundColor: '#faf8fc', 
          borderRadius: '8px',
          color: '#374151', 
          fontSize: '14px', 
          fontWeight: '600' 
        }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <span style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Total Amount (USD)</span>
            <span style={{ color: '#3b82f6', fontSize: '16px' }}>
              USD {data.data.reduce((sum, item) => sum + Number(item.amount_usd || 0), 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <span style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Total Discount (USD)</span>
            <span style={{ color: '#10b981', fontSize: '16px' }}>
              USD {data.data.reduce((sum, item) => sum + Number(item.discount_usd || 0), 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <span style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Total Taxes (USD)</span>
            <span style={{ color: '#f59e0b', fontSize: '16px' }}>
              USD {data.data.reduce((sum, item) => sum + Number(item.taxes_usd || 0), 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <span style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>NET Total (USD)</span>
            <span style={{ color: '#8b5cf6', fontSize: '16px' }}>
              USD {data.data.reduce((sum, item) => sum + Number(item.converted_total_usd || 0), 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
          </div>
        </div>
      )}

      <DataTable columns={columns} rows={rows} loading={loadingFull} />
      <Discrepancy
        open={discrepancyModal}
        setOpen={setDiscrepancyModal}
        discrepancyData={discrepancyData}
        invoiceNo={invoiceNo}
        selectedColumn={selectedColumn}
      />
    </>
  );
}

export default LocationDetail;
